module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/4-on-df0c31122f25e5bf82bd633d8e310c7c.png";